(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var catalogKey = 'ng-title-catalog-v1';
  var resultKey = 'ng-title-search';

  function words(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim().split(/\s+/).filter(Boolean);
  }

  function titleText(value) {
    return words(value).join(' ');
  }

  function esc(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function compact(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function productPath(itemOrHandle) {
    var base = root.replace(/\/?$/, '/');
    if (itemOrHandle && typeof itemOrHandle === 'object') {
      if (itemOrHandle.c) return base + 'product/' + encodeURIComponent(itemOrHandle.c);
      return base + 'products/' + itemOrHandle.h;
    }
    return base + 'products/' + itemOrHandle;
  }

  function suggest(term) {
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=10&resources[options][fields]=title,variants.sku';
    return fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    }).then(function (data) {
      return (data.resources && data.resources.results && data.resources.results.products) || [];
    });
  }

  function loadCatalog() {
    try {
      var cached = sessionStorage.getItem(catalogKey);
      if (cached) return Promise.resolve(JSON.parse(cached));
    } catch (error) {}

    function page(number) {
      return fetch(root + 'collections/all?view=ng-rows&page=' + number, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        });
    }

    return page(1).then(function (first) {
      var items = (first.items || []).slice();
      var pages = first.pages || 1;
      var numbers = [];
      var index = 0;
      for (var n = 2; n <= pages; n++) numbers.push(n);

      function worker() {
        if (index >= numbers.length) return Promise.resolve();
        var number = numbers[index++];
        return page(number).then(function (data) {
          items = items.concat(data.items || []);
          return worker();
        });
      }

      var workers = [];
      for (var i = 0; i < 4; i++) workers.push(worker());
      return Promise.all(workers).then(function () {
        items = items.filter(function (item) {
          return item && item.handle && item.title && item.suffix !== 'category';
        }).map(function (item) {
          return { c: item.code || '', h: item.handle, t: item.title || '', g: item.type || '' };
        });
        try { sessionStorage.setItem(catalogKey, JSON.stringify(items)); } catch (error) {}
        return items;
      });
    });
  }

  function matches(items, term) {
    var queryWords = words(term);
    var queryCompact = compact(term);
    var queryTitle = titleText(term);
    if (!queryCompact) return [];
    var exact = [];
    var partial = [];
    items.forEach(function (item) {
      var title = titleText(item.t);
      var titleCompact = compact(item.t);
      var codeCompact = compact(item.c);
      if (!titleCompact && !codeCompact) return;
      if ((queryTitle && title === queryTitle) || (codeCompact && codeCompact === queryCompact)) {
        exact.push(item);
        return;
      }
      var hit = queryWords.every(function (word) {
        return titleCompact.indexOf(word) !== -1 || codeCompact.indexOf(word) !== -1;
      });
      if (hit) partial.push(item);
    });
    exact.sort(function (a, b) { return a.t.localeCompare(b.t); });
    partial.sort(function (a, b) { return a.t.localeCompare(b.t); });
    return exact.concat(partial);
  }

  function goToProduct(item) {
    window.location.assign(productPath(item));
  }

  function showResults(term, items) {
    try {
      sessionStorage.setItem(resultKey, JSON.stringify({ q: term, items: items }));
    } catch (error) {}
    window.location.assign(root + 'search?type=product&title=1&q=' + encodeURIComponent(term.trim()));
  }

  function nativeSubmit(form, term) {
    var input = form.querySelector('input[name="q"]');
    if (input) input.value = term;
    form.dataset.titlePass = '1';
    form.submit();
  }

  function fromSuggest(products, term) {
    return matches(products.map(function (product) {
      var sku = '';
      if (product.variants && product.variants[0]) sku = product.variants[0].sku || '';
      return { c: sku, h: product.handle, t: product.title || '', g: product.type || '' };
    }), term);
  }

  function mergeHits(lists) {
    var seen = {};
    var found = [];
    lists.forEach(function (list) {
      (list || []).forEach(function (item) {
        var key = item.h || item.c;
        if (!key || seen[key]) return;
        seen[key] = true;
        found.push(item);
      });
    });
    return found;
  }

  function searchTitle(form, term) {
    form.setAttribute('aria-busy', 'true');
    Promise.all([
      suggest(term).catch(function () { return []; }),
      loadCatalog().catch(function () { return []; })
    ]).then(function (parts) {
      var found = mergeHits([fromSuggest(parts[0], term), matches(parts[1], term)]);
      var queryCompact = compact(term);
      var queryTitle = titleText(term);
      found.sort(function (a, b) {
        function rank(item) {
          if (compact(item.c) === queryCompact) return 0;
          if (titleText(item.t) === queryTitle) return 1;
          return 2;
        }
        var diff = rank(a) - rank(b);
        if (diff) return diff;
        return a.t.localeCompare(b.t);
      });
      if (!found.length) {
        nativeSubmit(form, term);
        return;
      }
      var exactCode = found.filter(function (item) { return compact(item.c) === queryCompact; });
      if (exactCode.length === 1) {
        goToProduct(exactCode[0]);
        return;
      }
      if (found.length === 1) {
        goToProduct(found[0]);
        return;
      }
      showResults(term, found);
    }).catch(function () {
      nativeSubmit(form, term);
    });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.classList) return;
    var ingredientSearch = form.classList.contains('ng-hero-search') || form.classList.contains('ngp__search') || form.classList.contains('ng-home-hero__search') || form.classList.contains('ngc__search');
    if (!ingredientSearch) return;
    if (event.defaultPrevented || form.dataset.titlePass === '1') return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var term = input.value.trim();
    if (!term) return;
    event.preventDefault();
    searchTitle(form, term);
  });

  function renderStored() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('title') !== '1') return;
    var card = document.querySelector('.ngsr__card');
    if (!card) return;
    var stored;
    try { stored = JSON.parse(sessionStorage.getItem(resultKey) || ''); } catch (error) { return; }
    if (!stored || titleText(stored.q) !== titleText(params.get('q') || '')) return;
    var items = stored.items || [];
    if (!items.length) return;

    card.querySelectorAll('.ngsr__summary, .ngsr__jump, .ngsr__group, .ngsr__pagination, .ngsr__empty').forEach(function (node) {
      node.remove();
    });

    var groups = {};
    items.forEach(function (item) {
      var name = item.g || 'Other';
      if (!groups[name]) groups[name] = [];
      groups[name].push(item);
    });
    var names = Object.keys(groups).sort(function (a, b) { return a.localeCompare(b); });

    var summary = document.createElement('p');
    summary.className = 'ngsr__summary';
    summary.textContent = items.length + ' ingredients found';
    card.appendChild(summary);

    names.forEach(function (name) {
      var rows = groups[name].map(function (item) {
        var href = productPath(item);
        return '<tr><td>' + esc(item.c) + '</td><td><a href="' + esc(href) + '">' + esc(item.t) + '</a></td><td>' + esc(name) + '</td></tr>';
      }).join('');
      var group = document.createElement('div');
      group.className = 'ngsr__group';
      group.innerHTML =
        '<h2 class="ngsr__group-title">' + esc(name) + '</h2>' +
        '<div class="ngsr__table-wrap"><table class="ngsr__table"><thead><tr><th scope="col">Code</th><th scope="col">Name</th><th scope="col">Group</th></tr></thead><tbody>' +
        rows + '</tbody></table></div>';
      card.appendChild(group);
    });
  }

  renderStored();
})();
